export default __webpack_public_path__ + "static/media/salvador.dc30e118.jpg";